import { createContext, useContext, useState, useCallback, type ReactNode } from 'react'
import { translations, ptCorrections } from './translations'

type Language = 'pt' | 'en'

interface LanguageContextType {
  language: Language
  setLanguage: (lang: Language) => void
  t: (text: string) => string
}

const LanguageContext = createContext<LanguageContextType>({
  language: 'pt',
  setLanguage: () => {},
  t: (text) => text,
})

export function LanguageProvider({ children }: { children: ReactNode }) {
  const [language, setLanguageState] = useState<Language>(() => {
    return (localStorage.getItem('conectagran-lang') as Language) || 'pt'
  })

  const setLanguage = useCallback((lang: Language) => {
    setLanguageState(lang)
    localStorage.setItem('conectagran-lang', lang)
  }, [])

  const t = useCallback((text: string): string => {
    if (language === 'pt') return ptCorrections[text] || text
    return translations[text] || text
  }, [language])

  return (
    <LanguageContext.Provider value={{ language, setLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  )
}

export function useLanguage() {
  return useContext(LanguageContext)
}
